import React from "react";
import { useNavigate, useSearchParams, Link } from "react-router-dom";
import { toast } from "sonner";
import { Loader2, Lock, CheckCircle2 } from "lucide-react";
import { api } from "../lib/api";
import { Logo } from "../components/layout/Navbar";

export default function AdminResetPasswordPage() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const [pw1, setPw1] = React.useState("");
  const [pw2, setPw2] = React.useState("");
  const [busy, setBusy] = React.useState(false);
  const [done, setDone] = React.useState(false);
  const nav = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    if (pw1 !== pw2) {
      toast.error("De to passwords er ikke ens");
      return;
    }
    if (pw1.length < 10) {
      toast.error("Password skal være mindst 10 tegn");
      return;
    }
    setBusy(true);
    try {
      await api.post("/admin/reset-password", { token, new_password: pw1 });
      setDone(true);
      toast.success("Password opdateret");
      setTimeout(() => nav("/admin/login"), 2000);
    } catch (err) {
      const msg = err?.response?.data?.detail || "Kunne ikke opdatere password";
      toast.error(typeof msg === "string" ? msg : "Ugyldigt link");
    } finally {
      setBusy(false);
    }
  };

  if (!token) {
    return (
      <div className="min-h-screen bg-brand-bg2 flex items-center justify-center p-5" data-testid="admin-reset-no-token">
        <div className="w-full max-w-md bg-white border border-brand p-8">
          <Logo />
          <h1 className="font-display font-bold text-2xl text-brand-dark mt-6">Ugyldigt link</h1>
          <p className="text-sm text-brand-dark/80 mt-3">Linket mangler en gyldig token. Anmod om et nyt fra glemt-password siden.</p>
          <Link to="/admin/forgot-password" className="btn-primary w-full justify-center mt-5" data-testid="admin-reset-retry">
            Anmod om nyt link
          </Link>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-brand-bg2 flex items-center justify-center p-5" data-testid="admin-reset-page">
      <div className="w-full max-w-md">
        <div className="bg-white border border-brand p-8 sm:p-10">
          <Logo />
          <div className="kicker mt-7">Admin · Nyt password</div>
          <h1 className="font-display font-bold text-3xl text-brand-dark mt-2">Vælg nyt password</h1>

          {done ? (
            <div className="mt-7 space-y-4 text-center" data-testid="admin-reset-done">
              <CheckCircle2 size={48} className="text-green-600 mx-auto" />
              <p className="text-brand-dark">Dit password er opdateret. Sender dig til login...</p>
            </div>
          ) : (
            <form onSubmit={submit} className="mt-7 space-y-4" data-testid="admin-reset-form">
              <div>
                <label className="label-flat">Nyt password (min. 10 tegn)</label>
                <input
                  type="password"
                  className="input-flat"
                  value={pw1}
                  onChange={(e) => setPw1(e.target.value)}
                  data-testid="admin-reset-pw1"
                  required
                  minLength={10}
                  autoFocus
                />
              </div>
              <div>
                <label className="label-flat">Gentag nyt password</label>
                <input
                  type="password"
                  className="input-flat"
                  value={pw2}
                  onChange={(e) => setPw2(e.target.value)}
                  data-testid="admin-reset-pw2"
                  required
                  minLength={10}
                />
              </div>
              <button type="submit" className="btn-primary w-full justify-center" disabled={busy} data-testid="admin-reset-submit">
                {busy ? <><Loader2 className="animate-spin" size={16} /> Gemmer...</> : <><Lock size={16} /> Opdater password</>}
              </button>
            </form>
          )}
        </div>
      </div>
    </div>
  );
}
